export default {
      id: "ic_play-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.svg#ic_play",
      toString: function () {
        return this.url;
      }
    }